import { PlasticsManufacturingRatesVersion } from './plastics-manufacturing-rates-version.model';
import { QuoteStudioCostModelVersion, QuoteStudioLink } from './quote-studio.model';

/** the cost of one variation of one version, split the way the costing sheet splits it */
export interface QuoteStudioCostBreakdown {
    material: number;
    machine: number;
    /** flat per-part adder on anything moulded: consumables and the mould repair fund */
    moldingFixed: number;
    moldedIn: number;
    labor: number;
    secondary: number;
    packaging: number;
    linked: number;
    /** the scrap allowance: everything above, times the variation's scrap percent */
    scrap: number;
    /** sales commission: the same base, times the variation's commission percent */
    commission: number;
    total: number;
}

export const QUOTE_STUDIO_EMPTY_BREAKDOWN: Readonly<QuoteStudioCostBreakdown> = Object.freeze({
    material: 0, machine: 0, moldingFixed: 0, moldedIn: 0, labor: 0, secondary: 0, packaging: 0, linked: 0, scrap: 0, commission: 0, total: 0,
});

/**
 * The live price of one hardware item, as the studio quotes it: ONE entry per
 * item, priced from the item's default vendor when that vendor can be priced,
 * else from the cheapest usable vendor row. Costing needs nothing more than
 * this; the browser picker carries a richer row built from the same choice.
 */
export interface QuoteStudioCatalogPrice {
    hardwareItemId: string;
    partNumber: string;
    description: string;
    units: string;
    /** vendor cost / packageQuantity — the live per-unit price */
    unitCost: number;
}

export type QuoteStudioCatalogPrices = ReadonlyMap<string, QuoteStudioCatalogPrice> | Readonly<Record<string, QuoteStudioCatalogPrice>>;

/**
 * Everything the cost math reads. The browser builds one from its loaded
 * board; the Agent API builds one from the same tables. Links join versions,
 * so the versions list must include every child a link points at, or that
 * component silently costs nothing.
 */
export interface QuoteStudioCostingContext {
    versions: readonly QuoteStudioCostModelVersion[];
    links: readonly QuoteStudioLink[];
    rates: PlasticsManufacturingRatesVersion;
    catalog: QuoteStudioCatalogPrices;
}
